import { loadFailureKind } from "./pilots";

// A 403/404 on the prospect means "not reachable for this caller" (no distinction: no existence oracle); anything else
// (network, 5xx) is worth a retry.
export const classifyProspectLoad = (error) => (loadFailureKind(error) === "error" ? "error" : "unavailable");

// The direct link to the pilot is offered only when an authorised answer for THIS prospect's pilot has been received.
export const canOfferPilotLink = (pilotState, prospectId) =>
  !!pilotState && pilotState.status === "ready" && !!pilotState.data && pilotState.data.prospect_id === prospectId;
